import { QA_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";

export const QaService = {
  getAll: (params: any) => requests.get(`${QA_URL}`, params),
  create: (params: any) => requests.post(`${QA_URL}`, params),
  getSingle: (id: number) => requests.get(`${QA_URL}/${id}`),
  update: (params: any, id: number) => requests.put(`${QA_URL}/${id}`, params),
  delete: (id: number) => requests.delete(`${QA_URL}/${id}`),
};